/**
 * Düğüncüm tanıtım (SaaS landing) sitesi merkezi yapılandırması.
 *
 * Buradaki tüm metin/sabitler tek noktadan yönetilir; iletişim bilgilerini
 * değiştirmek için sadece bu dosyayı düzenlemeniz yeterlidir.
 */

/* -------------------------------------------------------------------------- */
/*  İletişim                                                                   */
/* -------------------------------------------------------------------------- */

/**
 * WhatsApp iletişim numarası — uluslararası formatta, sadece rakamlar.
 * ÖNEMLİ: Aşağıdaki numarayı kendi WhatsApp hattınızla değiştirin.
 */
export const WHATSAPP_NUMBER = '904426060662';

/** İnsanların okuyacağı biçimde telefon (buton/altbilgi görünümü). */
export const WHATSAPP_DISPLAY = '+90 442 606 06 62';

export const CONTACT_EMAIL = 'bilgi@duguntakibi.com.tr';

/** Yönetim paneline geçiş adresi (basename ile ayrı ağaç, tam sayfa geçiş). */
export const ADMIN_URL = '/yonetim';

/** Yönetim paneli üyelik oluşturma (kayıt) sayfası — "Ücretsiz Dene" hedefidir. */
export const REGISTER_URL = `${ADMIN_URL}/auth/registration`;

/** Mobil uygulama mağaza bağlantıları. Google Play henüz yayında değil (null → "Pek yakında"). */
export const APP_STORE_URL = 'https://apps.apple.com/tr/app/d%C3%BC%C4%9F%C3%BCnc%C3%BCm-mobil/id6755928693?l=tr';
export const PLAY_STORE_URL: string | null = null;

/**
 * WhatsApp konuşması başlatan bağlantı üretir. Plan adı verilirse mesaja eklenir.
 */
export function whatsappLink(planName?: string): string {
  const base = 'Merhaba, Düğüncüm hakkında bilgi almak istiyorum.';
  const text = planName ? `${base} İlgilendiğim paket: ${planName}.` : base;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

/* -------------------------------------------------------------------------- */
/*  Fiyatlandırma planları                                                     */
/* -------------------------------------------------------------------------- */

export type Plan = {
  id: string;
  name: string;
  tagline: string;
  price: string; // ₺ / ay ya da "Ücretsiz"
  priceSuffix?: string;
  period?: string;
  highlight?: boolean;
  badge?: string;
  ctaLabel: string;
  features: { text: string; included: boolean }[];
};

export const PLANS: Plan[] = [
  {
    id: 'free',
    name: 'Başlangıç',
    tagline: 'Düğüncüm’ü keşfetmek için ideal.',
    price: 'Ücretsiz',
    period: '1 ay deneme',
    ctaLabel: 'Ücretsiz Başla',
    features: [
      { text: '1 ay boyunca ücretsiz kullanım', included: true },
      { text: 'Web yönetim paneli erişimi', included: true },
      { text: 'Rezervasyon & başvuru takibi', included: true },
      { text: 'Temel finans ve kasa yönetimi', included: true },
      { text: 'Mobil uygulama erişimi', included: false },
      { text: 'SMS bildirim servisleri', included: false },
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    tagline: 'Butik işletmeler için güçlü çekirdek.',
    price: '499',
    priceSuffix: '₺',
    period: 'aylık',
    highlight: true,
    badge: 'En Popüler',
    ctaLabel: 'Pro ile İletişime Geç',
    features: [
      { text: 'Web + mobil uygulama erişimi', included: true },
      { text: '1 kullanıcı hesabı', included: true },
      { text: 'Sınırsız rezervasyon & müşteri', included: true },
      { text: 'Finans, kasa ve raporlama', included: true },
      { text: 'Personel & komisyon takibi', included: true },
      { text: 'SMS bildirim servisleri', included: false },
    ],
  },
  {
    id: 'max',
    name: 'Max',
    tagline: 'Büyüyen ekipler için sınırsız güç.',
    price: '999',
    priceSuffix: '₺',
    period: 'aylık',
    badge: 'Sınırsız Kullanıcı',
    ctaLabel: 'Max ile İletişime Geç',
    features: [
      { text: 'Web + mobil uygulama erişimi', included: true },
      { text: 'Sınırsız kullanıcı hesabı', included: true },
      { text: 'Sınırsız rezervasyon & müşteri', included: true },
      { text: 'Gelişmiş finans, kasa ve raporlama', included: true },
      { text: 'Personel, komisyon & şube yönetimi', included: true },
      { text: 'SMS bildirim servisleri dahil', included: true },
    ],
  },
];
